// ============================================================
// Paradise Canvas Prints — sitewide PDP enhancements
// Add this as a theme asset ONCE, load it in theme.liquid, and
// it applies to every PageFly product page automatically —
// no per-product editing needed.
//
// What this does:
//  1. Hides the "Material" variant (CSS, injected below)
//  2. Renames "Size" -> "Choose the size of your canvas print"
//     and "Frame" -> "Select a floating frame" (JS)
// ============================================================

(function () {
  // ---- 1. Inject the Material-hide CSS ----
  var css =
    'label[for^="material-"],' +
    'select[data-option-name="Material"] {' +
    '  display: none !important;' +
    '}' +
    '.pf-option-swatches:has(select[data-option-name="Material"]) {' +
    '  display: none !important;' +
    '}';

  var styleTag = document.createElement("style");
  styleTag.setAttribute("data-kh-source", "pdp-global-enhancements");
  styleTag.textContent = css;
  document.head.appendChild(styleTag);

  // ---- 2. Relabel Size and Frame variant labels ----
  function relabel() {
    document.querySelectorAll('label[data-pf-type="OptionLabel"]').forEach(function (label) {
      var forAttr = (label.getAttribute("for") || "").toLowerCase();
      if (forAttr.indexOf("size") === 0) {
        label.textContent = "Choose the size of your canvas print";
      } else if (forAttr.indexOf("frame") === 0) {
        label.textContent = "Select a floating frame";
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", relabel);
  } else {
    relabel();
  }
  setTimeout(relabel, 800); // safety re-check for late PageFly render
})();